<template>
	<div>
		<el-form label-width="50px" :model="form" style="width:80%;">
			<el-form-item label="">
				<!-- <p class="b_p_b">生产工艺 </p> -->
				<ep-title title="生产工艺"></ep-title>
				<p class="b_p">是否涉及危险工艺过程或国家规定的禁用工艺/设备是（多选）</p>
				<el-radio-group v-model="form.isRiskInvolved">
					<el-radio :label="1" style="width:60px;">是</el-radio>
					<el-radio :label="2" style="width:80px;">否</el-radio>
				</el-radio-group>
				<transition name="el-fade-in-linear">
					<el-checkbox-group v-model="checkList8" @change="changeArr1" v-if="form.isRiskInvolved == 1">
						<el-checkbox label="1" :disabled="disabled1">具有国家规定有淘汰期限的淘汰类落后生产工艺装备</el-checkbox>
						<el-checkbox label="2" :disabled="disabled1">属于《重点监管危险化工工艺目录》</el-checkbox>
						<el-checkbox label="3" :disabled="disabled1">易燃</el-checkbox>
						<el-checkbox label="4" :disabled="disabled1">易爆</el-checkbox>
						<el-checkbox label="5" :disabled="disabled1">高温</el-checkbox>
						<el-checkbox label="6" :disabled="disabled1">高压</el-checkbox>
					</el-checkbox-group>
				</transition>
			</el-form-item>
			<el-form-item label="">
				<ep-title title="安全生产控制"></ep-title>
				<p class="b_p">消防验收</p>
				<p>消防验收意见是否合格</p>
				<el-radio-group v-model="form.isFireProtectionQualified">
					<el-radio :label="1" style="width:60px;">合格</el-radio>
					<el-radio :label="2" style="width:80px;">不合格</el-radio>
				</el-radio-group>
				<p>最近一次消防检查是否合格</p>
				<el-radio-group v-model="form.isLastFireProtectionQualified">
					<el-radio :label="2" style="width:60px;">合格</el-radio>
					<el-radio :label="1" style="width:80px;">不合格</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="">
				<p class="b_p">安全生产许可（单选）</p>
				<el-radio-group v-model="form.safeProductionPermit" size="small">
					<el-radio :label="1">非危险化学品生产企业</el-radio>
					<el-radio :label="2">危险化学品生产企业取得安全生产许可</el-radio>
					<el-radio :label="3">危险化学品生产企业未取得安全生产许可</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="">
				<p class="b_p">危险化学品安全评价（单选）</p>
				<el-radio-group v-model="form.safetyValuationOfDangerousChemicals" size="small">
					<el-radio :label="1">开展危险化学品安全评价并通过验收</el-radio>
					<el-radio :label="2">开展危险化学品安全评价未通过验收</el-radio>
					<el-radio :label="3">未开展危险化学品安全评价</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="">
				<p class="b_p">危险化学品重大危险源备案（单选）</p>
				<el-radio-group v-model="form.majorHazardOfDangerousChemicals" size="small">
					<el-radio :label="1">无重大危险源</el-radio>
					<el-radio :label="2">所有危险化学品重大危险源均已备案</el-radio>
					<el-radio :label="3">有危险化学品重大危险源未备案</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="">
				<!-- <p class="b_p_b">环境风险防控与应急措施 </p> -->
				<ep-title title="环境风险防控与应急措施"></ep-title>
				<p class="b_p">是否有截流措施(多选)</p>
				<el-radio-group v-model="form.hasInterceptMeasure">
					<el-radio :label="1" style="width:60px;">是</el-radio>
					<el-radio :label="2" style="width:80px;">否</el-radio>
				</el-radio-group>
				<transition name="el-fade-in-linear">
					<el-checkbox-group v-model="checkList3" @change="changeArr3" v-if="form.hasInterceptMeasure == 1">
						<el-checkbox label="1">各个环境风险单元设防渗漏、防腐蚀、防淋溶、防流失措施，设防初期 雨水、泄漏物、受污染的消防水（溢）流入雨水和清净下水系统的导流 围挡收集措施（如防火堤、围堰等），且相关措施符合设计规范</el-checkbox>
						<el-checkbox label="2">装置围堰与罐区防火堤（围堰）外设排水切换阀，正常情况下通向雨水 系统的阀门关闭，通向事故存液池、应急事故水池、清净下水排放缓冲 池或污水处理系统的阀门打开</el-checkbox>
						<el-checkbox label="3">前述措施日常管理及维护良好，有专人负责阀门切换，保证初期雨水、 泄漏物和受污染的消防水排入污水系统</el-checkbox>
					</el-checkbox-group>
				</transition>
			</el-form-item>
			<el-form-item label="">
				<p class="b_p">是否有事故排水收集措施（多选）</p>
				<el-radio-group v-model="form.hasAccidentDrainageCollectionMeasure">
					<el-radio :label="1" style="width:60px;">是</el-radio>
					<el-radio :label="2" style="width:80px;">否</el-radio>
				</el-radio-group>
				<el-checkbox-group v-model="checkList4" @change="changeArr4" v-if="form.hasAccidentDrainageCollectionMeasure == 1">
					<el-checkbox label="1">按相关设计规范设置应急事故水池、事故存液池或清净下水排放缓冲池 等事故排水收集设施，并根据下游环境风险受体敏感程度和易发生极端 天气情况，设置事故排水收集设施的容量</el-checkbox>
					<el-checkbox label="2">事故存液池、应急事故水池、清净下水排放缓冲池等事故排水收集设施 位置合理，能自流式或确保事故状态下顺利收集泄漏物和消防水，日常 保持足够的事故排水缓冲容量</el-checkbox>
					<el-checkbox label="3">设抽水设施，并与污水管线连接，能将所收集物送至厂区内污水处理设施处理</el-checkbox>
				</el-checkbox-group>
			</el-form-item>
			<el-form-item label="">
				<p class="b_p">清净下水系统防控措施（单选）</p>
				<el-radio-group v-model="form.cleanWaterSystemProtectionMeasure">
					<el-radio :label="1" style="width:150px;">不涉及清净下水</el-radio>
					<el-radio :label="2" style="width:150px;">涉及清净下水（多选）</el-radio>
				</el-radio-group>
				<transition name="el-fade-in-linear">
					<el-form-item label="" v-if="form.cleanWaterSystemProtectionMeasure == 2">
						<el-checkbox-group v-model="checkList53" @change="changeArr6">
							<el-checkbox label="1" :disabled="disabled2">具有收集受污染的清净下水、初期雨水和消防水功能的清净下水排放缓 冲池（或雨水收集池），池内日常保持足够的事故排水缓冲容量；池内设 有提升设施，能将所集物送至厂区内污水处理设施处理</el-checkbox>
							<el-checkbox label="2" :disabled="disabled2">具有清净下水系统（或排入雨水系统）的总排口监视及关闭设施，有 专人负责在紧急情况下关闭清净下水总排口，防止受污染的雨水、清净 下水、消防水和泄漏物进入外环境</el-checkbox>
							<el-checkbox label="3">以上都没有</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
				</transition>
			</el-form-item>
			<el-form-item label="">
				<p class="b_p">雨排水系统防控措施（多选）</p>
				<el-checkbox-group v-model="checkList6" @change="changeArr7">
					<el-checkbox label="1" :disabled="disabled3">具有收集初期雨水的收集池或雨水监控池；池出水管上设置切断阀，正 常情况下阀门关闭，防止受污染的水外排；池内设有提升设施，能将所集 物送至厂区内污水处理设施处理</el-checkbox>
					<el-checkbox label="2" :disabled="disabled3">具有雨水系统外排总排口（含泄洪渠）监视及关闭设施，有专人负责 在紧急情况下关闭雨水排口（含与清净下水共用一套排水系统情况）， 防止雨水、消防水和泄漏物进入外环境</el-checkbox>
					<el-checkbox label="3" :disabled="disabled3">如果有排洪沟，排洪沟不通过生产区和罐区，具有防止泄漏物和受污 染的消防水流入区域排洪沟的措施</el-checkbox>
					<el-checkbox label="4">以上都没有</el-checkbox>
				</el-checkbox-group>
			</el-form-item>
			<el-form-item label="">
				<!-- <p class="b_p_b">生产废水处理系统防控措施</p> -->
				<ep-title title="生产废水处理系统防控措施"></ep-title>
				<p class="b_p">是否有废水产生或外排（多选）</p>
				<el-radio-group v-model="form.hasWasteWater">
					<el-radio :label="1" style="width:60px;">是</el-radio>
					<el-radio :label="2" style="width:80px;">否</el-radio>
				</el-radio-group>
				<el-checkbox-group v-model="checkList" @change="changeArr8" v-if="form.hasWasteWater == 1">
					<el-checkbox label="1" :disabled="disabled4">受污染的循环冷却水、雨水、消防水等排入生产污水系统或独立处理系统</el-checkbox>
					<el-checkbox label="2" :disabled="disabled4">生产废水排放前设监控池，能够将不合格废水送废水处理设施重新处理</el-checkbox>
					<el-checkbox label="3" :disabled="disabled4">如企业受污染的清净下水或雨水进入废水处理系统处理，则废水处理 系统应设置事故水缓冲设施</el-checkbox>
					<el-checkbox label="4" :disabled="disabled4">具有生产废水总排口监视及关闭设施，有专人负责启闭，确保泄漏物、 受污染的消防水、不合格废水不排出厂外</el-checkbox>
					<el-checkbox label="5">以上都没有</el-checkbox>
				</el-checkbox-group>
			</el-form-item>
			<el-form-item label="">
				<p class="b_p">毒性气体泄漏紧急处置装置（单选）</p>
				<el-radio-group v-model="form.toxicGasLeakEmerDisposalDevice">
					<el-radio label="1">不涉及有毒有害气体</el-radio>
					<el-radio label="2">涉及有毒有害气体，不具备有毒有害气体泄漏紧急处置装置</el-radio>
					<el-radio label="3">涉及有毒有害气体，具有针对有毒有害气体（如硫化氢、氰化氢、氯化氢、 光气、氯气、氨气、苯等）的泄漏紧急处置措施</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="">
				<p class="b_p">毒性气体泄漏监控预警措施（单选）</p>
				<el-radio-group v-model="form.toxicGasLeakEmerMonitorMeasure">
					<el-radio label="1">不涉及有毒有害气体</el-radio>
					<el-radio label="2">涉及有毒有害气体，不具备生产区域或厂界有毒有害气体泄漏监控预警措施的</el-radio>
					<el-radio label="3">涉及有毒有害气体，具有针对有毒有害气体（如硫化氢、氰化氢、氯化氢、 光气、氯气、氨气、苯等）设置生产区域或厂界泄漏监控预警措施</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="" class="arr_b">
				<p class="b_p">环评及批复的其他风险防控措施落实情况（单选）</p>
				<el-radio-group v-model="form.otherRiskControlSituation">
					<el-radio label="1">按环评及批复文件的要求落实的其他建设环境风险防控设施的。</el-radio>
					<el-radio label="2">未落实环评及批复文件中其他环境风险防控设施要求的。</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="" class="arr_b">
				<p class="b_p">雨排水、清净下水、生产废水排放去向（单选）</p>
				<el-radio-group v-model="form.waterEmission">
					<el-radio label="1">不产生废水或废水处理后100%回用</el-radio>
					<el-radio label="2">进入城市污水处理厂或工业废水集中处理厂（如工业园区的废水处理厂）</el-radio>
					<el-radio label="3">进入其它单位</el-radio>
					<el-radio label="4">其他（包括回喷、回灌、回用等）</el-radio>
					<el-radio label="5">直接进入海域或江河、湖、库等水环境</el-radio>
					<el-radio label="6">进入城市下水道再入江河湖库或进入城市下水道再入沿海海域</el-radio>
					<el-radio label="7">直接进入污灌农田或进入地渗或蒸发地</el-radio>
				</el-radio-group>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	import Burst from './../../data/emer/burst.js'
	import Vmap from './map'
	export default {
		components: {
			Vmap
		},
		data() {
			return {
				checkList53: [],
				checkList8: [],
				// 生产工艺 
				disabled1: false,
				checkbox1: false,
				// 多选
				checkList: [],
				// 环境风险防控与应急措施
				checkList3: [],
				checkbox2: false,
				radio5: 2,
				radio6: 2,
				checkList4: [],
				checkbox4: false,
				// 清净下水系统防控措施（单选）
				checkList5: [],
				checkbox5: false,
				disabled2: false,
				checkList6: [],
				checkbox6: false,
				disabled3: false,
				disabled4: false,
				// 基本信息
				form: {
					accidentDrainageCollectionMeasures: '',
					cleanWaterSystemProtectionMeasure: '',
					cleanWaterSystemProtectionMeasureSub: '',
					hasAccidentDrainageCollectionMeasure: 2,
					hasInterceptMeasure: 2,
					hasWasteWater: 2,
					interceptMeasures: '',
					// 工艺
					involvedRisks: '',
					isFireProtectionQualified: '',
					isLastFireProtectionQualified: '',
					isRiskInvolved: 2,
					majorHazardOfDangerousChemicals: '',
					otherRiskControlSituation: '',
					planId: '',
					rainWaterSystemProtectionMeasure: '',
					// 生产许可
					safeProductionPermit: '',
					safetyValuationOfDangerousChemicals: '',
					toxicGasLeakEmerDisposalDevice: '',
					toxicGasLeakEmerMonitorMeasure: '',
					wasteWaterSystemProtectionMeasure: '',
					waterEmission: ''
				},
			}
		},
		watch: {
			form: {
				handler() {
					this.save_sensprotection()
				},
				deep: true
			}
		},
		created() {
			if(!sessionStorage.planIdval) return
			this.form.planId = sessionStorage.planIdval
			this.get_sensprotection()
			setTimeout(() => {
				this.form.planId = sessionStorage.planIdval
			}, 1000)
		},
		methods: {

			// 验证
			verifyRes() {
				for(let it in this.form) {
					if(it == 'involvedRisks' || it == 'interceptMeasures' || it == 'accidentDrainageCollectionMeasures' || it == 'cleanWaterSystemProtectionMeasureSub' || it == 'wasteWaterSystemProtectionMeasure') {
						continue
					}
					if(it === 'isRiskInvolved' && this.form['isRiskInvolved'] === 1) {
						if(!this.form['involvedRisks']) {
							return {
								status: false,
								msg: '工艺和环境风险控制操作信息不完善，请填写'
							}
						}
					}
					if(it === 'hasInterceptMeasure' && this.form['hasInterceptMeasure'] === 1) {
						if(!this.form['interceptMeasures']) {
							return {
									status: false,
								msg: '工艺和环境风险控制操作信息不完善，请填写'
							}
						}
					}
					if(it === 'hasAccidentDrainageCollectionMeasure' && this.form['hasAccidentDrainageCollectionMeasure'] === 1) {
						if(!this.form['accidentDrainageCollectionMeasures']) {
							return {
									status: false,
								msg: '工艺和环境风险控制操作信息不完善，请填写'
							}
						}
					}
					if(it === 'cleanWaterSystemProtectionMeasure' && this.form['cleanWaterSystemProtectionMeasure'] === 2) {
						if(!this.form['cleanWaterSystemProtectionMeasureSub']) {
							return {
									status: false,
								msg: '工艺和环境风险控制操作信息不完善，请填写'
							}
						}
					}
					if(it === 'hasWasteWater' && this.form['hasWasteWater'] === 1) {
						if(!this.form['wasteWaterSystemProtectionMeasure']) {
							return {
									status: false,
								msg: '工艺和环境风险控制操作信息不完善，请填写'
							}
						}
					}
					if(!this.form[it]) {
						return {
									status: false,
								msg: '工艺和环境风险控制操作信息不完善，请填写'
							}
					}
				}
				return {
					status: true,
					msg: 'ok'
				}
			},
			// 工艺和环境风险控制操作(单页面)
			save_sensprotection() {
				(async() => {
					try {
						let sen = await Burst.risk_save(this.form)
						if(!sen.status) {
							this.$message.success('网络异常，请稍后重试')
						}
					} catch(err) {
						console.log(err)
					}
				})()
			},

			// 工艺和环境风险控制操作(单页面)
			get_sensprotection() {
				(async() => {
					try {
						let pID = sessionStorage.planIdval
						let sen = await Burst.risk_detail({
							id: pID
						})
						if(sen.status) {
							this.form = sen.data || {}
							this.form.safeProductionPermit = parseInt(this.form.safeProductionPermit)
							this.form.safetyValuationOfDangerousChemicals = parseInt(this.form.safetyValuationOfDangerousChemicals)
							this.form.majorHazardOfDangerousChemicals = parseInt(this.form.majorHazardOfDangerousChemicals)
							this.form.cleanWaterSystemProtectionMeasure = parseInt(this.form.cleanWaterSystemProtectionMeasure)
							if(this.form.accidentDrainageCollectionMeasures == null) {
								this.checkList4 = []
							} else {
								this.checkList4 = this.form.accidentDrainageCollectionMeasures.split(',')
							}
							if(this.form.rainWaterSystemProtectionMeasure == null) {
								this.checkList6 = []
							} else {
								this.checkList6 = this.form.rainWaterSystemProtectionMeasure.split(',')
							}
							if(this.form.wasteWaterSystemProtectionMeasure == null) {
								this.checkList = []
							} else {
								this.checkList = this.form.wasteWaterSystemProtectionMeasure.split(',')
							}
							if(this.form.involvedRisks == null) {
								this.checkList8 = []
							} else {
								this.checkList8 = this.form.involvedRisks.split(',')
							}
							if(this.form.cleanWaterSystemProtectionMeasureSub == null) {
								this.checkList53 = []
							} else {
								this.checkList53 = this.form.cleanWaterSystemProtectionMeasureSub.split(',')
							}
						}
					} catch(error) {
						this.$message.error(error.msg)
					}
				})()
			},
			// 工艺
			// change1(data) {
			//   if (data == 1) {
			//     this.checkbox1 = true
			//   } else {
			//     this.checkbox1 = false
			//     this.form.involvedRisks = ''
			//   }
			// },
			changeArr1(data) {
				this.form.involvedRisks = data.toString()
			},
			changeArr3(data) {
				this.form.interceptMeasures = data.toString()
			},
			changeArr4(data) {
				this.form.accidentDrainageCollectionMeasures = data.toString()
			},
			changeArr6(data) {
				for(let i = 0; i < data.length; i++) {
					if(data[i] == 3) {
						this.checkList53.splice(0, data.length, '3')
						this.disabled2 = true
					}
				}
				if(data.length == 0) {
					this.disabled2 = false
				}
				this.form.cleanWaterSystemProtectionMeasureSub = this.checkList53.toString()
			},
			changeArr7(data) {
				for(let i = 0; i < data.length; i++) {
					if(data[i] == 4) {
						this.checkList6.splice(0, data.length, '4')
						this.disabled3 = true
					}
				}
				if(data.length == 0) {
					this.disabled3 = false
				}
				this.form.rainWaterSystemProtectionMeasure = this.checkList6.toString()
			},
			changeArr8(data) {
				for(let i = 0; i < data.length; i++) {
					if(data[i] == 5) {
						this.checkList.splice(0, data.length, '5')
						this.disabled4 = true
					}
				}
				if(data.length == 0) {
					this.disabled4 = false
				}
				this.form.wasteWaterSystemProtectionMeasure = this.checkList.toString()
			},
		}
	}
</script>
<style scoped lang="stylus">
	.el-checkbox,
	.el-checkbox__input {
		white-space: normal
	}
	
	.el-form-item {
		margin-bottom: 20px;
	}
	
	.el-form-item__content {
		position: relative;
		left: -15px;
	}
	
	.el-checkbox-group {
		position: relative;
		left: -15px;
		label {
			display: block;
			line-height: 30px;
			&:first-child {
				margin-left: 15px;
			}
			span {
				word-break: normal;
				width: auto;
				display: block;
				white-space: pre-wrap;
				word-wrap: break-word;
				overflow: hidden;
			}
		}
	}
	
	.el-form-item__content {
		.el-radio-group {
			label {
				line-height: 30px;
				&:first-child {
					white-space: normal;
				}
			}
		}
	}
	
	.arr_bs {
		label {
			&:nth-child(2) {
				margin-left: 0;
			}
		}
	}
	
	.b_p {
		position: relative;
		left: 0px;
		font-weight: bold;
	}
	
	.b_p_b {
		font-size: 18px;
		font-weight: bold;
	}
	
	.el-radio-group {
		label {
			width: 100%;
			&:nth-child(n+1) {
				margin-left: 0;
			}
		}
	}
	
	.head-title {
		border-bottom: none!important;
		font-size: 18px;
		font-weight: bold;
	}
</style>


// WEBPACK FOOTER //
// process.vue?5b7ae71a